"use client";

import React from "react";
import {
    // Reaction icons
    Heart,
    Handshake,
    Flame,
    ThumbsUp,
    Hand,
    Leaf,
    HeartHandshake,
    FishSymbol,
    // Other icons
    MessageCircle,
    UsersRound,
    UserPlus2,
    UserMinus2,
    ShieldAlert,
    AlertTriangle,
    Sparkles,
    Bell,
    BookOpen,
    HeartOff,
} from "lucide-react";

/**
 * Returns the correct icon for each notification type.
 * Reaction icons use the official TownLIT reaction set;
 * non-reaction icons use generic Lucide symbols.
 */
export const getTypeIcon = (type?: string) => {
    const iconProps = { size: 18, className: "notif-icon" };

    // ✅ safe normalization
    const t = (type || "UNKNOWN").toUpperCase();

    switch (t) {
        // ─────────────────────────────
        // 🗨️  COMMENTS
        // ─────────────────────────────
        case "NEW_COMMENT":
        case "NEW_REPLY":
        case "NEW_REPLY_POST_OWNER":
            return <MessageCircle {...iconProps} />;

        // ─────────────────────────────
        // 💖 REACTIONS (TownLIT set)
        // ─────────────────────────────
        case "NEW_REACTION_LIKE":
            return <Heart {...iconProps} />;
        case "NEW_REACTION_BLESS":
            return <FishSymbol {...iconProps} />;
        case "NEW_REACTION_AMEN":
            return <Hand {...iconProps} />;
        case "NEW_REACTION_GRATITUDE":
            return <Leaf {...iconProps} />;
        case "NEW_REACTION_ENCOURAGEMENT":
            return <ThumbsUp {...iconProps} />;
        case "NEW_REACTION_EMPATHY":
            return <HeartHandshake {...iconProps} />;
        case "NEW_REACTION_FAITHFIRE":
            return <Flame {...iconProps} />;
        case "NEW_REACTION_SUPPORT":
            return <Handshake {...iconProps} />;

        // ─────────────────────────────
        // 👥 FRIENDSHIPS
        // ─────────────────────────────
        case "FRIEND_REQUEST_RECEIVED":
            return <UserPlus2 {...iconProps} />;
        case "FRIEND_REQUEST_ACCEPTED":
            return <Handshake {...iconProps} />;
        case "FRIEND_REQUEST_DECLINED":
            return <UserMinus2 {...iconProps} />;
        case "FRIEND_REQUEST_CANCELLED":
            return <AlertTriangle {...iconProps} />;
        case "FRIENDSHIP_DELETED":
            return <UserMinus2 {...iconProps} />;

        // ─────────────────────────────
        // 🙌 FELLOWSHIPS (spiritual)
        // ─────────────────────────────
        case "FELLOWSHIP_REQUEST_RECEIVED":
            return <Sparkles {...iconProps} />;
        case "FELLOWSHIP_REQUEST_ACCEPTED":
        case "FELLOWSHIP_REQUEST_CONFIRMED":
            return <HeartHandshake {...iconProps} />;
        case "FELLOWSHIP_REQUEST_DECLINED":
        case "FELLOWSHIP_DECLINE_NOTICE":
            return <AlertTriangle {...iconProps} />;
        case "FELLOWSHIP_CANCELLED":
            return <HeartOff {...iconProps} />;


        // ─────────────────────────────
        // 🔔 GENERAL / SYSTEM
        // ─────────────────────────────
        case "SYSTEM_ALERT":
            return <ShieldAlert {...iconProps} />;
        case "SYSTEM_INFO":
            return <Bell {...iconProps} />;
        case "NEW_ANNOUNCEMENT":
            return <BookOpen {...iconProps} />;

        // ─────────────────────────────
        // DEFAULT
        // ─────────────────────────────
        default:
            return <Bell {...iconProps} />;
    }
};
